import { io, Socket } from 'socket.io-client';
import { APP_URLS } from './constants.utils';
import { DefaultEventsMap } from '@socket.io/component-emitter';
import { createPause } from './utils.helper';
import { fetchManager } from './network.utils';

class SocketProvider {
  private _socket: Socket<DefaultEventsMap, DefaultEventsMap> | undefined;
  private channels: Map<string, { args: any; callback: (body: any) => void }> = new Map();
  private onDisconnect: Map<string, () => void> = new Map();
  private canExecuteOnDisconnect: boolean = false;
  socketInit = async (
    userId: string,
    token: string,
  ): Promise<Socket<DefaultEventsMap, DefaultEventsMap>> => {
    if (this._socket) {
      return this._socket;
    }

    const socket = io(APP_URLS.BASE, {
      auth: {
        'auth-token': token,
      },
      transports: ['websocket'],
      path: '/socket.io',
      secure: true,
      reconnectionAttempts: 0, // Set the number of reconnection attempts
      reconnection: false,
      retries: 0,
    });

    socket.on('connect', () => {
      console.log('connected');
      console.log('socket-connected', socket);
      console.log('this socket', this._socket);
      socket.emit('user-online', userId);
      this.reconnectChannels(socket);
    });

    this._socket = socket;
    await createPause(2000);

    const interval = setInterval(async () => {
      //always run this to see if socket is connected
      if (!this._socket) {
        clearInterval(interval);
        this._socket = await this.socketInit(userId, token); //connect new
        return;
      }
      if (this._socket.disconnected) {
        console.log('Disconnected');
        clearInterval(interval);
        this._socket.io._destroy(this._socket!); //destory old one
        this._socket = undefined;
        const newToken = (await fetchManager.getHeaders())['auth-token'];
        this._socket = await this.socketInit(userId, newToken); //connect new
        if (this.canExecuteOnDisconnect) {
          this.onDisconnect.forEach((func) => func());
        }
        this.canExecuteOnDisconnect = false;
      }
      if (this._socket.connected) {
        this.canExecuteOnDisconnect = true;
      }
    }, 10000); // every 10 seconds

    socket.on('connect_error', (err) => {
      console.log(err);
    });

    return socket;
  };

  getSocket = () => {
    return this._socket!;
  };

  addToChannels = (channel: string, args: any, callback: (body: any) => void) => {
    this.channels.set(channel, { args, callback });
    console.log('Added ', this.channels);
  };
  removeFromChannels = (channel: string) => {
    console.log('Existing Channels ', this.channels);
    console.log('Removing ', channel);
    this.channels.delete(channel);
    console.log('Removed ', this.channels);
  };

  addToOnDisconnect(id: string, func: () => void) {
    this.onDisconnect.set(id, func);
  }

  private reconnectChannels = (socket: Socket<DefaultEventsMap, DefaultEventsMap>) => {
    for (const [channel, { args, callback }] of this.channels.entries()) {
      console.log('re-emitting: ', channel, ' ', args);
      socket.emit(channel, args);
      socket.on(channel, callback);
    }
  };
}

export const socketProvider = new SocketProvider();
